import React, { Component } from 'react'
import ThemePicker from './ThemePicker'
import '../styles/BookingContainer.css'
import DatePicker from './DatePicker'
import ThemeCalendar from './ThemeCalendar'
import AllThemesCalendar from './AllThemesCalendar'
import ThemesCart from './ThemesCart'
import LearnMoreButton from './LearnMoreButton'
import PopIn from './PopIn'
import PopInVBNCustom from './PopInVBNCustom'
import PopInVideoPack from './PopInVideoPack'
import PlayersPicker from './PlayersPicker'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import moment from 'moment'
import 'moment/locale/fr'
import FAQPattern from '../images/FAQ/FAQpattern.png'
import { API_ROOT } from '../api-config'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import smoothscroll from 'smoothscroll'
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'
import LAIconSmall from '../images/Themes/icon-small-la.png'
import VBNIconSmall from '../images/Themes/icon-small-vbn.png'
import AbattoirIconSmall from '../images/Themes/icon-small-abattoir.png'
import YakuzaIconSmall from '../images/Themes/icon-small-yakuza.png'
import TombeauIconSmall from '../images/Themes/icon-small-tombeau.png'
import { Cookies } from 'react-cookie-banner'
import { injectIntl, defineMessages } from 'react-intl'
import { Link } from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { cartCookieOptions, clearCartCookies, safeBookingsForCookie, safeOrderDetailsForCookie } from './CartCookieStorage'

const getweekDays = (date, lang) => {
  let aDate
  if (lang === "fr") {
    aDate = moment(date.startOf('week'))
  } else {
    aDate = moment(date.startOf('week')).add(1, 'days')
  }

  const weekDays = []
  weekDays.push(formatWeekDay(aDate, lang))

  for (let i = 0; i < 6; i++) {
    weekDays.push(formatWeekDay(aDate.add(1, 'days'), lang))
  }

  return weekDays
}

const formatWeekDay = (date, lang) => {
  const dayString = date.format('llll').split(" ")
  const dayArray = []

  if (lang === "fr") {
    for (let i = 0; i < 2; i++) {
      dayArray.push(dayString[i])
    }

    return dayArray.join(' ')
  } else {
    return `${dayString[0]} ${dayString[2].substring(0, dayString[2].length - 1)}`
  }
}

const formatDate = (date, lang) => {
  const arr = date.format('l').split('/')

  if (lang === "fr") {
    return `${arr[2]}-${arr[1]}-${arr[0]}`
  } else {
    return `${arr[2]}-${arr[0]}-${arr[1]}`
  }
}

const asMomentDate = (date) => {
  return date && date.isoWeek ? date : moment(date)
}

const getWeek = (date) => {
  return asMomentDate(date).isoWeek()
}

const getYear = (date) => {
  return asMomentDate(date).format('l').split('/').slice(-1).join()
}

const formatRoom = (theme) => {
  switch (theme) {
    case 'la':
      return 27
    case 'vbn':
      return 28
    case 'abattoir':
      return 29
    case 'yakuza':
      return 31
    case 'tombeau':
      return 32
    default:
      break
  }
}

const invertFormatRoom = (code) => {
  switch (`${code}`) {
    case '1':
    case '27':
      return "la"
    case '2':
    case '28':
      return "vbn"
    case '5':
    case '29':
      return "abattoir"
    case '6':
    case '31':
      return "yakuza"
    case '4':
    case '32':
      return "tombeau"
    default:
      break
  }
}

const normalizeRoomName = (roomName) => {
  return (roomName || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
}

const roomThemeFromName = (roomName) => {
  const normalizedName = normalizeRoomName(roomName)

  if (normalizedName.includes("lost")) return "la"
  if (normalizedName.includes("very") || normalizedName.includes("vbn")) return "vbn"
  if (normalizedName.includes("abattoir")) return "abattoir"
  if (normalizedName.includes("yakuza")) return "yakuza"
  if (normalizedName.includes("expedition") || normalizedName.includes("maudite") || normalizedName.includes("tombeau")) return "tombeau"

  return null
}

const DEFAULT_COMPANY_ID = "30"
const LOCAL_COMPANY_ID_FALLBACK = "1"
const LOCAL_ROOM_IDS_BY_THEME = {
  la: 1,
  vbn: 2,
  abattoir: 5,
  yakuza: 6,
  tombeau: 4
}
const THEME_ORDER = ['la', 'vbn', 'abattoir', 'yakuza', 'tombeau']

const isLocalFront = () => {
  if (typeof window === "undefined" || !window.location) return false
  return window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost"
}

const getInitialCompanyId = () => {
  if (typeof window !== "undefined" && window.location) {
    const params = new URLSearchParams(window.location.search)
    const forcedCompanyId = params.get("id_company") || params.get("company_id")
    if (forcedCompanyId) return forcedCompanyId
  }

  return DEFAULT_COMPANY_ID
}

const getCompanyIdCandidates = (preferredCompanyId) => {
  const candidates = [`${preferredCompanyId || getInitialCompanyId()}`]

  if (isLocalFront()) {
    candidates.push(candidates[0] === LOCAL_COMPANY_ID_FALLBACK ? DEFAULT_COMPANY_ID : LOCAL_COMPANY_ID_FALLBACK)
  }

  return candidates.filter((id, index, allIds) => id && allIds.indexOf(id) === index)
}

const buildAPI_URL = (theme, date, lang, roomId = null, companyId = getInitialCompanyId()) => {
  if (theme === "all") {
    const formattedDate = moment(date).format('YYYY-MM-DD')
    return `${API_ROOT}FrontGetCalendarCompany.php?id_company=${companyId}&date=${formattedDate}`
  } else {
    const formattedRoom = roomId || formatRoom(theme)
    const calendarDate = asMomentDate(date)
    const week = getWeek(calendarDate)
    // Was fetching wrong year when 1st week of year was beginning with a day of year n-1
    // Ex : Monday of 1st week was 2018/12/31
    const dayNumOfFirstDayOfYear = new Date(parseInt(getYear(calendarDate)) + 1, 0, 1).getDay();
    const year = (week == 1 && 1 != dayNumOfFirstDayOfYear) ? parseInt(getYear(calendarDate), 10) + 1 : getYear(calendarDate)

    return `${API_ROOT}FrontGetCalendarRoom.php?id_room=${formattedRoom}&week=${week}&year=${year}`
  }
}

const createMoment = (date) => {
  let year, month, day

  year = date.split('-')[0]
  month = date.split('-')[1] - 1
  day = date.split('-')[2]

  return moment({
    y: year,
    M: month,
    d: day
  })
}

const createMomentFromEnglish = (date, lang) => {
  let year, month, day

  if (lang === "fr") {
    day = date.split('/')[0]
    month = date.split('/')[1] - 1
    year = date.split('/')[2]

    return moment({
      y: year,
      M: month,
      d: day
    })
  } else {
    day = date.split('/')[1]
    month = date.split('/')[0] - 1
    year = date.split('/')[2]
    return moment({
      y: year,
      M: month,
      d: day
    })
  }
}

const themeToImageConverter = (code) => {
  switch (code) {
    case 'la':
      return LAIconSmall
    case 'vbn':
      return VBNIconSmall
    case 'abattoir':
      return AbattoirIconSmall
    case 'yakuza':
      return YakuzaIconSmall
    case 'tombeau':
      return TombeauIconSmall
    default:
      break
  }
}

const encodeLanguage = (lang) => {
  switch (lang) {
    case "french":
      return "fr"
    case "english":
      return "en"
    default:
      break
  }
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

const CALENDAR_REQUEST_TIMEOUT = 8000
const ROOM_PRICING_CACHE_PREFIX = 'onehour-room-pricing-v3'
const ROOM_PRICING_CACHE_TTL = 7 * 24 * 60 * 60 * 1000

const getRoomPricingCacheKey = (companyId) => `${ROOM_PRICING_CACHE_PREFIX}-${companyId}`

const readRoomPricingCache = (companyId) => {
  if (typeof window === "undefined" || !window.localStorage) return null

  try {
    const cached = JSON.parse(window.localStorage.getItem(getRoomPricingCacheKey(companyId)))
    if (!cached || !Array.isArray(cached.rooms) || !cached.storedAt) return null
    if (Date.now() - cached.storedAt > ROOM_PRICING_CACHE_TTL) return null
    return cached.rooms
  } catch (error) {
    return null
  }
}

const writeRoomPricingCache = (companyId, rooms) => {
  if (typeof window === "undefined" || !window.localStorage || !Array.isArray(rooms)) return

  try {
    window.localStorage.setItem(getRoomPricingCacheKey(companyId), JSON.stringify({
      storedAt: Date.now(),
      rooms
    }))
  } catch (error) {
    // Browsers can reject localStorage in private mode; pricing still works without cache.
  }
}

const parseCalendarSlotValue = (slot) => {
  const parts = `${slot || ''}`.split('|')
  return {
    theme: parts[0] || '',
    date: parts[1] || '',
    hour: parts[2] || '',
    calendarId: parts[3] || '',
    minutes: parts[4] || '',
    roomId: parts[5] || '',
    discountRaw: parts.length > 6 ? parts[6] : '',
    priceType: parts[7] || ''
  }
}

const AccessibleSelectValue = ({ children, id }) => (
  <span className="Select-value-label" id={id}>
    {children}
  </span>
)

const getEnglishHour = (hour) => {
  const parsedHour = parseInt(hour, 10)
  if (!Number.isFinite(parsedHour)) return ""
  const englishHour = parsedHour % 12
  return englishHour === 0 ? "12" : englishHour.toString()
}

const getEnglishHourAMPM = (hour) => {
  const parsedHour = parseInt(hour, 10)
  if (!Number.isFinite(parsedHour)) return ""
  return parsedHour >= 12 ? "PM" : "AM"
}

const buildAPI_URL_Order = (idReservation, tokenReservation) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idReservation}&token_order=${tokenReservation}`
}

class BookingContainer extends Component {
  constructor(props) {
    super(props)

    if (this.props.lang === "fr") {
      moment.locale('fr')
    } else {
      moment.locale('en')
    }

    const theme = this.props.theme ? this.props.theme : "all"
    this.bookingSubmitInProgress = false
    this.activeCompanyId = getInitialCompanyId()
    this.roomPricingByCompany = {}
    this.roomPricingPromiseByCompany = {}
    this.roomPricingRefreshPromiseByCompany = {}
    this.roomPricingValidatedByCompany = {}
    this.companyCalendarByDate = {}
    this.companyCalendarPromiseByDate = {}

    this.state = {
      date: moment(new Date()),
      weekDays: getweekDays(moment(new Date()), this.props.lang),
      selectedTheme: theme,
      currentSlot: null,
      selectedSlots: [],
      bookings: [],
      slots: [],
      weekSlots: [],
      showPopIn: false,
      showPopInEdit: false,
      showPopInLimitBooking: false,
      bookingToEdit: null,
      bookingPlayersToEdit: 0,
      bookingPriceToEdit: 0,
      showPopInVBNCustom: false,
      showPopInVideoPack: false,
      players: 4,
      language: this.props.lang === "fr" ? "french" : "english",
      playersQuantityInfo: null,
      isPricing: false,
      isEditPricing: false,
      VBNOption: false,
      VBNOptionPrice: 0,
      roomIdsByTheme: {},
      roomOptionsByRoom: {},
      priceType: null,
      totalPrice: 0,
      firstOrder: false,
      calendarKey: 1,
      companyId: this.activeCompanyId,
      loading: false
    }
  }

  getThemeOrder = () => {
    const allowedThemes = Array.isArray(this.props.allowedThemes) ? this.props.allowedThemes : THEME_ORDER
    return THEME_ORDER.filter(theme => allowedThemes.indexOf(theme) > -1)
  }

  changeDate = async (date) => {
    await this.setState({
        date: date,
        loading: true
      })
    if (this.state.selectedTheme !== "all") {
      await this.setState({
        weekDays: getweekDays(date, this.props.lang)
      })
    }
    await this.buildSchedules(this.state.selectedTheme, this.state.date)
    smoothscroll(document.getElementById("booking-smoothscroll-level"))
  }

  changeTheme = async (theme) => {
    await this.setState({
      selectedTheme: theme
    })

    const date = this.state.date

    if (theme !== "all") {
      await this.setState({
        weekDays: getweekDays(date, this.props.lang)
      })
    } else {
      await this.setState({
        date: moment()
      })
    }
    await this.buildSchedules(theme, this.state.date)
  }

  displayLanguage = (lang) => {
    switch(lang) {
      case "french":
        return "Français"
      case "english":
        return "English"
      default:
        break
    }
  }

  codeToThemeConverter = (theme) => {
    const {intl:{formatMessage}} = this.props

    switch (theme) {
      case "la":
      case "vbn":
      case "abattoir":
      case "yakuza":
      case "tombeau":
        return theme
      case formatMessage(messages.la):
        return "la"
      case formatMessage(messages.VBN):
        return "vbn"
      case formatMessage(messages.slaughterhouse):
        return "abattoir"
      case formatMessage(messages.yakuza):
        return "yakuza"
      case formatMessage(messages.tombeau):
        return "tombeau"
      default:
        break
    }
  }

  themeCodeConverter = (code) => {
    const {intl:{formatMessage}} = this.props

    switch (code) {
      case 'la':
        return formatMessage(messages.la)
      case 'vbn':
        return formatMessage(messages.VBN)
      case 'abattoir':
        return formatMessage(messages.slaughterhouse)
      case 'yakuza':
        return formatMessage(messages.yakuza)
      case 'tombeau':
        return formatMessage(messages.tombeau)
      default:
        break
    }
  }

  buildSchedules = async (theme, date) => {
    this.setState({loading: true});

    let roomIdsByTheme = Object.keys(this.state.roomIdsByTheme).length > 0
      ? this.state.roomIdsByTheme
      : (this.roomIdsByThemeCache || {})

    const setFallbackSchedules = async () => {
      if (theme === "all") {
        let fallbackSlots = []

        try {
          fallbackSlots = await this.buildAllThemeSlotsFromRooms(date, roomIdsByTheme)
        } catch (error) {
          console.log(error)
        }

        if (!fallbackSlots || fallbackSlots.length === 0) {
          const fallbackRoomIds = Object.keys(roomIdsByTheme || {}).length > 0
            ? roomIdsByTheme
            : (isLocalFront() ? LOCAL_ROOM_IDS_BY_THEME : {})

          fallbackSlots = this.getThemeOrder()
            .map(themeCode => ({
              id_room: this.resolveRoomId(themeCode, null, fallbackRoomIds),
              calendar: []
            }))
            .filter(slot => slot.id_room)
        }

        this.setState({ slots: fallbackSlots, loading: false })
      } else {
        this.setState({ weekSlots: this.buildEmptyWeekSlots(date), loading: false })
      }
    }

    try {
      if (Object.keys(roomIdsByTheme).length === 0) {
        roomIdsByTheme = await this.getRoomIdsByTheme()
      }

      if (!roomIdsByTheme || Object.keys(roomIdsByTheme).length === 0) {
        roomIdsByTheme = isLocalFront() ? LOCAL_ROOM_IDS_BY_THEME : {}
      }

      if (Object.keys(this.state.roomOptionsByRoom).length === 0) {
        try {
          await this.getVBNOptionPrice()
        } catch (error) {
          console.log(error)
        }
      }

      const roomId = theme === "all" ? null : this.resolveRoomId(theme, null, roomIdsByTheme)

      const companyIds = getCompanyIdCandidates(this.getCompanyId())

      for (let i = 0; i < companyIds.length; i++) {
        const companyId = companyIds[i]
        try {
          const response = await axios.get(buildAPI_URL(theme, date, this.props.lang, roomId, companyId), {
            timeout: CALENDAR_REQUEST_TIMEOUT
          })
          const hasValidSlots = response.data && response.data.result !== false && Array.isArray(response.data.slots)
          let slots = hasValidSlots ? response.data.slots : []

          if (hasValidSlots && theme === "all" && slots.length === 0) {
            slots = await this.buildAllThemeSlotsFromRooms(date, roomIdsByTheme, companyId)
          }

          if (hasValidSlots && theme !== "all" && slots.length === 0) {
            slots = this.buildEmptyWeekSlots(date)
          }

          if (hasValidSlots && theme !== "all" && slots.length > 0) {
            slots = await this.mergeCompanyPromosIntoWeekSlots(slots, roomId, companyId)
          }

          if (hasValidSlots && (slots.length > 0 || i === companyIds.length - 1)) {
            theme === "all"
              ? this.setState({ slots })
              : this.setState({ weekSlots: slots })

            this.activeCompanyId = companyId
            this.setState({ companyId, loading: false })
            return response
          }
        } catch (error) {
          console.log(error)
        }
      }

      await setFallbackSchedules()
    } catch (error) {
      console.log(error)
      await setFallbackSchedules()
    }
  }

  buildEmptyWeekSlots = (date) => {
    const firstDay = this.props.lang === "fr"
      ? moment(date).startOf('week')
      : moment(date).startOf('week').add(1, 'days')

    return Array.from({ length: 7 }).map((_, index) => ({
      day: formatDate(moment(firstDay).add(index, 'days'), this.props.lang),
      calendar: []
    }))
  }

  getCalendarForSelectedDate = (weekSlots, date) => {
    const formattedDate = formatDate(moment(date), this.props.lang)
    const matchingDay = Array.isArray(weekSlots)
      ? weekSlots.filter(slot => slot && slot.day === formattedDate).shift()
      : null

    return matchingDay && Array.isArray(matchingDay.calendar) ? matchingDay.calendar : []
  }

  getCompanyCalendarForDate = async (date, companyId) => {
    const cacheKey = `${companyId}|${date}`
    if (this.companyCalendarByDate[cacheKey]) {
      return this.companyCalendarByDate[cacheKey]
    }
    if (!this.companyCalendarPromiseByDate[cacheKey]) {
      this.companyCalendarPromiseByDate[cacheKey] = axios.get(`${API_ROOT}FrontGetCalendarCompany.php?id_company=${companyId}&date=${date}`, {
        timeout: CALENDAR_REQUEST_TIMEOUT
      }).then(response => {
        const slots = response.data && Array.isArray(response.data.slots) ? response.data.slots : []
        this.companyCalendarByDate[cacheKey] = slots
        return slots
      })
      .catch(error => {
        console.log(error)
        return []
      })
      .then(slots => {
        delete this.companyCalendarPromiseByDate[cacheKey]
        return slots
      })
    }
    return this.companyCalendarPromiseByDate[cacheKey]
  }

  mergeCompanyPromosIntoWeekSlots = async (weekSlots, roomId, companyId) => {
    if (!Array.isArray(weekSlots) || weekSlots.length === 0 || !roomId) return weekSlots

    const discountByDayAndHour = {}
    await Promise.all(weekSlots.map(async (daySlot) => {
      if (!daySlot || !daySlot.day) return

      const companySlots = await this.getCompanyCalendarForDate(daySlot.day, companyId)
      const roomSlot = companySlots.filter(slot => {
        const slotRoomId = slot && (slot.id_room || slot.room_id)
        return `${slotRoomId}` === `${roomId}`
      }).shift()

      if (!roomSlot || !Array.isArray(roomSlot.calendar)) return

      roomSlot.calendar.forEach(calendarSlot => {
        if (!calendarSlot || !calendarSlot.time_begin) return

        const discountAmount = parseFloat(calendarSlot.last_minute_discount_amount || 0)
        const priceType = calendarSlot.global_price
        if (discountAmount > 0 || priceType) {
          discountByDayAndHour[`${daySlot.day}|${calendarSlot.time_begin}`] = {
            last_minute_discount_amount: discountAmount > 0 ? discountAmount : 0,
            global_price: priceType
          }
        }
      })
    }))

    return weekSlots.map(daySlot => {
      if (!daySlot || !Array.isArray(daySlot.calendar)) return daySlot

      return Object.assign({}, daySlot, {
        calendar: daySlot.calendar.map(calendarSlot => {
          const promo = calendarSlot && discountByDayAndHour[`${daySlot.day}|${calendarSlot.time_begin}`]
          return promo ? Object.assign({}, calendarSlot, promo) : calendarSlot
        })
      })
    })
  }

  buildAllThemeSlotsFromRooms = async (date, roomIdsByTheme, companyIdOverride = null) => {
    const companyId = companyIdOverride || this.getCompanyId()
    const companySlots = await this.getCompanyCalendarForDate(formatDate(moment(date), this.props.lang), companyId)
    if (Array.isArray(companySlots) && companySlots.length > 0) {
      return this.getThemeOrder().map(theme => {
        const roomId = this.resolveRoomId(theme, null, roomIdsByTheme)
        if (!roomId) return null

        const roomSlot = companySlots.filter(slot => {
          const slotRoomId = slot && (slot.id_room || slot.room_id)
          return `${slotRoomId}` === `${roomId}`
        }).shift()

        return {
          id_room: roomId,
          calendar: roomSlot && Array.isArray(roomSlot.calendar) ? roomSlot.calendar : []
        }
      }).filter(slot => slot)
    }

    const slots = await Promise.all(this.getThemeOrder().map(async (theme) => {
      const roomId = this.resolveRoomId(theme, null, roomIdsByTheme)
      if (!roomId) return null

      try {
        const response = await axios.get(buildAPI_URL(theme, date, this.props.lang, roomId, companyId), {
          timeout: CALENDAR_REQUEST_TIMEOUT
        })
        const weekSlots = response.data && response.data.result !== false && Array.isArray(response.data.slots)
          ? response.data.slots
          : []

        return {
          id_room: roomId,
          calendar: this.getCalendarForSelectedDate(weekSlots, date)
        }
      } catch (error) {
        console.log(error)
        return {
          id_room: roomId,
          calendar: []
        }
      }
    }))

    return slots.filter(slot => slot)
  }

  getCompanyId = () => {
    return this.activeCompanyId || this.state.companyId || getInitialCompanyId()
  }

  recalculateOpenPopinPrices = async () => {
    if (this.state.showPopIn && this.state.currentSlot) {
      const pricingRequestId = (this.pricingRequestId || 0) + 1
      this.pricingRequestId = pricingRequestId
      const priceType = this.state.priceType || await this.getPriceType(this.state.currentSlot)
      const totalPrice = await this.getTotalPrice(this.state.currentSlot, this.state.players, priceType)
      if (this.pricingRequestId === pricingRequestId && this.state.showPopIn) {
        this.setState({ priceType, totalPrice, isPricing: false })
      }
    }

    if (this.state.showPopInEdit && this.state.bookingToEdit) {
      const pricingRequestId = (this.editPricingRequestId || 0) + 1
      this.editPricingRequestId = pricingRequestId
      const slot = `${this.themeFromRoomId(this.state.bookingToEdit.room_id)}|${this.state.bookingToEdit.reservation_date}|${this.state.bookingToEdit.time_begin.split(":").shift()}|||${this.state.bookingToEdit.room_id}`
      const priceType = await this.getPriceType(slot)
      const totalPrice = await this.getTotalPrice(slot, this.state.bookingPlayersToEdit, priceType)
      if (this.editPricingRequestId === pricingRequestId && this.state.showPopInEdit) {
        this.setState({ bookingPriceToEdit: totalPrice, priceType, isEditPricing: false })
      }
    }
  }

  refreshRoomPricingData = (companyId = this.getCompanyId()) => {
    if (this.roomPricingRefreshPromiseByCompany[companyId]) {
      return this.roomPricingRefreshPromiseByCompany[companyId]
    }

    this.roomPricingRefreshPromiseByCompany[companyId] = axios.get(`${API_ROOT}/FrontGetInfosRoomPricingByCompany.php?id_company=${companyId}`, {
      timeout: CALENDAR_REQUEST_TIMEOUT
    })
      .then(response => {
        const rooms = response.data && Array.isArray(response.data.rooms) ? response.data.rooms : []
        this.roomPricingByCompany[companyId] = rooms
        this.roomPricingValidatedByCompany[companyId] = true
        writeRoomPricingCache(companyId, rooms)
        if (rooms.length > 0) {
          const roomIdsByTheme = Object.keys(this.state.roomIdsByTheme || {}).length > 0
            ? this.state.roomIdsByTheme
            : (this.roomIdsByThemeCache || {})
          const optionsByRoom = {}

          rooms.forEach(room => {
            const options = Array.isArray(room.options) ? room.options : []
            const roomId = room.id_room || room.id || room.room_id || room.id_room_escape || room.id_room_enigma
            const roomTheme = roomThemeFromName(`${room.room_name || ''} ${room.enigma_name || ''} ${room.roomname || ''} ${room.name || ''}`)

            if (roomId) optionsByRoom[roomId] = options
            if (roomTheme) {
              const mappedRoomId = roomIdsByTheme[roomTheme]
              if (mappedRoomId) optionsByRoom[mappedRoomId] = options
              if (LOCAL_ROOM_IDS_BY_THEME[roomTheme]) optionsByRoom[LOCAL_ROOM_IDS_BY_THEME[roomTheme]] = options
            }
          })

          this.roomOptionsByRoomCache = optionsByRoom
          this.setState({ roomOptionsByRoom: optionsByRoom })
          this.recalculateOpenPopinPrices()
        }
        return rooms
      })
      .catch(error => {
        console.log(error)
        return this.roomPricingByCompany[companyId] || []
      })
      .then(rooms => {
        delete this.roomPricingRefreshPromiseByCompany[companyId]
        return rooms
      })

    return this.roomPricingRefreshPromiseByCompany[companyId]
  }

  getRoomPricingData = async () => {
    const companyId = this.getCompanyId()
    if (this.roomPricingByCompany[companyId]) {
      if (!this.roomPricingValidatedByCompany[companyId]) {
        this.refreshRoomPricingData(companyId)
      }
      return this.roomPricingByCompany[companyId]
    }
    const cachedRooms = readRoomPricingCache(companyId)
    if (cachedRooms) {
      this.roomPricingByCompany[companyId] = cachedRooms
      this.roomPricingValidatedByCompany[companyId] = false
      this.refreshRoomPricingData(companyId)
      return cachedRooms
    }
    if (!this.roomPricingPromiseByCompany[companyId]) {
      this.roomPricingPromiseByCompany[companyId] = axios.get(`${API_ROOT}/FrontGetInfosRoomPricingByCompany.php?id_company=${companyId}`, {
        timeout: CALENDAR_REQUEST_TIMEOUT
      })
        .then(response => {
          const rooms = response.data && Array.isArray(response.data.rooms) ? response.data.rooms : []
          this.roomPricingByCompany[companyId] = rooms
          this.roomPricingValidatedByCompany[companyId] = true
          writeRoomPricingCache(companyId, rooms)
          return rooms
        })
        .catch(error => {
          console.log(error)
          return []
        })
        .then(rooms => {
          delete this.roomPricingPromiseByCompany[companyId]
          return rooms
        })
    }
    return this.roomPricingPromiseByCompany[companyId]
  }

  findRoomPricingInfo = (rooms, roomId) => {
    if (!Array.isArray(rooms)) return null

    const roomIdText = `${roomId}`
    const directMatch = rooms.filter(x => `${x.id_room}` === roomIdText).shift()
      || rooms.filter(x => `${x.id}` === roomIdText).shift()

    if (directMatch) return directMatch

    const theme = this.themeFromRoomId(roomId)
    if (!theme) return null

    return rooms.filter(room => (
      roomThemeFromName(`${room.room_name || ''} ${room.enigma_name || ''} ${room.roomname || ''} ${room.name || ''}`) === theme
    )).shift() || null
  }

  getRoomPricingInfo = async (roomId) => {
    const rooms = await this.getRoomPricingData()
    return this.findRoomPricingInfo(rooms, roomId)
  }

  getRoomPricingInfoSync = (roomId) => {
    const rooms = this.roomPricingByCompany[this.getCompanyId()] || []
    return this.findRoomPricingInfo(rooms, roomId)
  }

  getPlayerInfoForRoomSync = (roomId) => {
    const roomInfo = this.getRoomPricingInfoSync(roomId)
    if (roomInfo) {
      return {
        min: roomInfo.quantity_player_min,
        max: roomInfo.quantity_player_max
      }
    }
    const theme = this.themeFromRoomId(roomId)
    return {
      min: theme === 'tombeau' ? 1 : 2,
      max: theme === 'vbn' || theme === 'yakuza' || theme === 'tombeau' ? 6 : 5
    }
  }

  handleSelect = async (data) => {
    if (this.state.bookings.length > 5) {
      this.setState({ showPopInLimitBooking: true })
    } else if (!this.state.selectedSlots.includes(data)) {
      const room = this.resolveRoomId(data.split("|").shift(), data)
      const players = 4
      const pricingRequestId = (this.pricingRequestId || 0) + 1
      this.pricingRequestId = pricingRequestId
      this.setState({
        currentSlot: data,
        players,
        playersQuantityInfo: this.getPlayerInfoForRoomSync(room),
        priceType: null,
        totalPrice: 0,
        isPricing: true,
        showPopIn: true
      })

      try {
        const [playersQuantityInfo, priceType] = await Promise.all([
          this.getPlayerByRoom(room, data),
          this.getPriceType(data)
        ])
        const totalPrice = await this.getTotalPrice(data, players, priceType)
        if (this.pricingRequestId !== pricingRequestId) return
        this.setState({
          playersQuantityInfo,
          priceType,
          totalPrice,
          isPricing: false
        })
      } catch (error) {
        console.log(error)
        if (this.pricingRequestId === pricingRequestId) {
          this.setState({ isPricing: false })
        }
      }
    }
  }

  buildOrder = (data) => {
    let room, slot, date, roomId, minutes

    if (data.includes('|')) {
      const slotParts = data.split('|')
      room = this.codeToThemeConverter(slotParts[0]) || slotParts[0]
      slot = slotParts[2]
      minutes = slotParts[4] || '00'
      date = createMoment(slotParts[1])
      roomId = this.resolveRoomId(room, data)
    } else {
      room = this.codeToThemeConverter(data.split('-')[0]) || data.split('-')[0]
      slot = data.split('-')[1]
      minutes = '00'
      date = this.state.date
      roomId = this.resolveRoomId(room)
    }

    const players = this.state.players
    const language = this.state.language
    const price = this.state.totalPrice
    const reservationDate = date && date.format ? date.format('YYYY-MM-DD') : date
    const timeBegin = `${slot}`.indexOf(':') > -1 ? slot : `${slot}:${minutes}:00`

    return {
      room: room,
      room_id: roomId,
      room_name: this.themeCodeConverter(room),
      date: date,
      slot: slot,
      reservation_date: reservationDate,
      time_begin: timeBegin,
      quantity_player: players,
      lang: language,
      players: players,
      language: language,
      price: price
    }
  }

  getPlayerByRoom = async (room, slot) => {
    const codeRoom = this.resolveRoomId(room, slot)
    const roomInfo = await this.getRoomPricingInfo(codeRoom)
    if (!roomInfo) {
      return this.getPlayerInfoForRoomSync(codeRoom)
    }
    return {
      min: roomInfo.quantity_player_min,
      max: roomInfo.quantity_player_max
    }
  }

  displaySlot = (slot) => {

    if (slot) {
      const slotInfo = slot.split("|")

      const room = this.themeCodeConverter(slotInfo[0])
      const date = createMoment(slotInfo[1]).format('l')
      const hour = slotInfo[2]
      const minutes = slotInfo[4]

      return {
        room: room,
        date: date,
        hour: hour,
        minutes: minutes,
        language: this.state.language
      }
    }
  }

  selectSlot = (data) => {
    const slot = this.buildOrder(data)

    if (!this.state.selectedSlots.includes(slot)) {
      this.setState({
        selectedSlots: [...this.state.selectedSlots, slot],
        currentSlot: null
      })
    }
  }

  slotToDelete = (slot) => {
    return {
      room: this.codeToThemeConverter(slot.room) || slot.room,
      slot: slot.hour,
      date: createMomentFromEnglish(slot.date)
    }
  }

  togglePopIn = () => {
    this.setState({ showPopIn: !this.state.showPopIn })
  }

  togglePopInVBNCustom = () => {
    this.setState({ showPopInVBNCustom: !this.state.showPopInVBNCustom })
  }

  togglePopInVideoPack = () => {
    this.setState({ showPopInVideoPack: !this.state.showPopInVideoPack })
  }

  scrollToLastBooking = () => {
    if (document.getElementById("booking-cta")) {
      setTimeout(() => {
        const bookingCTA = document.getElementById("booking-cta")

        scrollIntoViewIfNeeded(bookingCTA, {
          duration: 500,
          easing: 'easeIn'
        })
      }, 200)
    }
  }

  setStateAsync = (state) => {
    return new Promise(resolve => this.setState(state, resolve))
  }

  refreshCurrentSlotPrice = async () => {
    if (!this.state.currentSlot) return false

    try {
      await this.setStateAsync({ isPricing: true })
      await this.refreshRoomPricingData(this.getCompanyId())
      const priceType = await this.getPriceType(this.state.currentSlot)
      const totalPrice = await this.getTotalPrice(this.state.currentSlot, this.state.players, priceType)
      await this.setStateAsync({ priceType, totalPrice })
      return true
    } finally {
      await this.setStateAsync({ isPricing: false })
    }
  }

  refreshEditSlotPrice = async () => {
    if (!this.state.bookingToEdit) return false

    try {
      await this.setStateAsync({ isEditPricing: true })
      await this.refreshRoomPricingData(this.getCompanyId())
      const slot = `${this.themeFromRoomId(this.state.bookingToEdit.room_id)}|${this.state.bookingToEdit.reservation_date}|${this.state.bookingToEdit.time_begin.split(":").shift()}|||${this.state.bookingToEdit.room_id}`
      const priceType = await this.getPriceType(slot)
      const totalPrice = await this.getTotalPrice(slot, this.state.bookingPlayersToEdit, priceType)
      await this.setStateAsync({ bookingPriceToEdit: totalPrice, priceType })
      return true
    } finally {
      await this.setStateAsync({ isEditPricing: false })
    }
  }

  checkSlotSelected = (slot) => {
    return this.state.selectedSlots.filter(x => x.slot === slot.slot).length > 0
  }

  handleContinueBooking = async () => {
    if (this.bookingSubmitInProgress || this.state.isPricing) return
    this.bookingSubmitInProgress = true

    try {
      const slotToBook = this.state.currentSlot
      if (!slotToBook) return
      await this.refreshCurrentSlotPrice()
      this.selectSlot(slotToBook)
      this.setState({ showPopIn: false })
      if (this.canAddBookingToExistingOrder()) {
        await this.addBookingToOrder(slotToBook)
      } else {
        this.clearInvalidBookingCart()
        await this.postCreateOrder(slotToBook)
      }
      this.updateBookings()
      this.buildSchedules(this.state.selectedTheme, this.state.date)
      this.scrollToLastBooking()
    } finally {
      this.bookingSubmitInProgress = false
    }
  }

  handleContinueBookingAfterEdit = async () => {
    if (this.editBookingInProgress || this.state.isEditPricing) return
    this.editBookingInProgress = true
    try {
      await this.refreshEditSlotPrice()
      const updated = await this.editBooking()
      if (!updated) return
      this.buildSchedules(this.state.selectedTheme, this.state.date)
      this.setState({ showPopInEdit: false })
    } finally {
      this.editBookingInProgress = false
    }
  }

  editBooking = async () => {
    const url = `${API_ROOT}FrontEditRoomReservation.php`

    const idReservation = this.state.bookingToEdit.id
    const tokenReservation = this.findToken(parseInt(this.state.bookingToEdit.id, 10))
    const quantityPlayer = this.state.bookingPlayersToEdit
    const price = this.state.bookingPriceToEdit
    const lang = encodeLanguage(this.state.language)

    const body = {
      id_reservation: idReservation,
      token_reservation: tokenReservation,
      quantity_player: quantityPlayer,
      price: price,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (!data || data.result === false || !data.order_details || !Array.isArray(data.order_details.rooms)) {
        throw new Error(data && data.message ? data.message : "Modification impossible")
      }
      const cookies = new Cookies()
      const bookings = data.order_details.rooms
      cookies.set('bookings', safeBookingsForCookie(bookings), cartCookieOptions())
      this.updateBookings()
      return true
    })
    .catch(error => {
      console.log(error)
      alert(error && error.message ? error.message : "Impossible de modifier la réservation")
      return false
    })
  }

  handleLanguage = (lang) => {
    this.setState({ language: lang })
  }

  getPricePerPlayer = (totalPrice, numberOfPlayers) => {
    return (totalPrice / numberOfPlayers).toFixed(2)
  }

  resolveRoomId = (theme, slot, roomIdsOverride = null) => {
    const slotRoomId = slot && slot.split("|")[5]
    if (slotRoomId) {
      return parseInt(slotRoomId, 10)
    }

    const productionRoomId = formatRoom(theme)
    const roomIdsByTheme = roomIdsOverride && Object.keys(roomIdsOverride).length > 0
      ? roomIdsOverride
      : Object.keys(this.state.roomIdsByTheme).length > 0
      ? this.state.roomIdsByTheme
      : (this.roomIdsByThemeCache || {})

    if (roomIdsByTheme[theme]) {
      return parseInt(roomIdsByTheme[theme], 10)
    }

    const roomOptionsByRoom = Object.keys(this.state.roomOptionsByRoom).length > 0
      ? this.state.roomOptionsByRoom
      : (this.roomOptionsByRoomCache || {})

    if (roomOptionsByRoom[productionRoomId]) {
      return productionRoomId
    }

    const fallbackIndexes = {
      la: 0,
      vbn: 1,
      abattoir: 2,
      yakuza: 3,
      tombeau: 4
    }
    const roomIds = Object.keys(roomOptionsByRoom)
    const fallbackRoomId = roomIds[fallbackIndexes[theme]]

    if (fallbackRoomId) {
      return parseInt(fallbackRoomId, 10)
    }

    if (isLocalFront() && LOCAL_ROOM_IDS_BY_THEME[theme]) {
      return LOCAL_ROOM_IDS_BY_THEME[theme]
    }

    return productionRoomId
  }

  themeFromRoomId = (roomId) => {
    const parsedRoomId = parseInt(roomId, 10)
    const roomIdsByTheme = Object.keys(this.state.roomIdsByTheme).length > 0
      ? this.state.roomIdsByTheme
      : (this.roomIdsByThemeCache || {})
    const mappedTheme = Object.keys(roomIdsByTheme).filter(theme => parseInt(roomIdsByTheme[theme], 10) === parsedRoomId).shift()

    return mappedTheme || invertFormatRoom(parsedRoomId)
  }

  getRoomIdsByTheme = async () => {
    if (this.roomIdsByThemeCache && Object.keys(this.roomIdsByThemeCache).length > 0) {
      return Promise.resolve(this.roomIdsByThemeCache)
    }

    const companyIds = getCompanyIdCandidates(this.getCompanyId())

    for (let i = 0; i < companyIds.length; i++) {
      const companyId = companyIds[i]
      try {
        const response = await axios.post(`${API_ROOT}GetRooms.php`, buildFormBody({ company_id: companyId }), {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          timeout: CALENDAR_REQUEST_TIMEOUT
        })
        let roomIdsByTheme = {}
        if (response.data && response.data.rooms) {
          response.data.rooms.forEach(room => {
            const roomName = `${room.room_name || ''} ${room.roomname || ''} ${room.name || ''} ${room.name_enigma || ''} ${room.enigma_name || ''} ${room.enigmaname || ''} ${room.enigma || ''} ${room.theme || ''} ${room.title || ''}`
            const theme = roomThemeFromName(roomName)
            const roomId = room.id || room.id_room || room.room_id || room.id_room_escape || room.id_room_enigma
            if (theme && roomId) {
              roomIdsByTheme[theme] = parseInt(roomId, 10)
            }
          })
        }

        if (Object.keys(roomIdsByTheme).length === 0 && isLocalFront() && i === companyIds.length - 1) {
          roomIdsByTheme = LOCAL_ROOM_IDS_BY_THEME
        }

        if (Object.keys(roomIdsByTheme).length > 0 || i === companyIds.length - 1) {
          this.roomIdsByThemeCache = roomIdsByTheme
          this.activeCompanyId = companyId
          this.setState({ roomIdsByTheme, companyId })
          return roomIdsByTheme
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (isLocalFront()) {
      this.roomIdsByThemeCache = LOCAL_ROOM_IDS_BY_THEME
      this.activeCompanyId = LOCAL_COMPANY_ID_FALLBACK
      this.setState({ roomIdsByTheme: LOCAL_ROOM_IDS_BY_THEME, companyId: LOCAL_COMPANY_ID_FALLBACK })
      return LOCAL_ROOM_IDS_BY_THEME
    }

    return {}
  }

  handleGoToCart = async () => {
    if (this.bookingSubmitInProgress || this.state.isPricing) return
    this.bookingSubmitInProgress = true

    try {
      const slotToBook = this.state.currentSlot
      if (!slotToBook) return
      await this.refreshCurrentSlotPrice()
      this.selectSlot(slotToBook)
      this.setState({ showPopIn: false })
      this.scrollToLastBooking()
      if (this.canAddBookingToExistingOrder()) {
        await this.addBookingToOrder(slotToBook)
      } else {
        this.clearInvalidBookingCart()
        this.setState({ firstOrder: true })
        await this.postCreateOrder(slotToBook)
      }
      await this.updateBookings()
      if (this.state.firstOrder) {
        this.props.history.push({
          pathname: "/cart",
          state: {
            new: true
          }
        })
        this.setState({ firstOrder: false })
      } else {
        this.props.history.push({
          pathname: "/cart"
        })
      }
    } finally {
      this.bookingSubmitInProgress = false
    }
  }

  getOrderCookie = () => {
    const cookies = new Cookies()
    const orderCookie = cookies.get('orderDetails')
    return orderCookie && orderCookie !== 'null' && orderCookie !== ''
      ? orderCookie
      : null
  }

  canAddBookingToExistingOrder = () => {
    const orderCookie = this.getOrderCookie()
    return this.state.bookings.length > 0
      && orderCookie
      && orderCookie.id_order_escape
      && orderCookie.id_order_escape_token
  }

  clearInvalidBookingCart = () => {
    if (this.state.bookings.length < 1) return
    clearCartCookies(new Cookies())
    this.setState({ bookings: [] })
  }

  handleGoToCartAfterEdit = async () => {
    if (this.editBookingInProgress || this.state.isEditPricing) return
    this.editBookingInProgress = true
    try {
      await this.refreshEditSlotPrice()
      const updated = await this.editBooking()
      if (!updated) return
      this.props.history.push({
        pathname: "/cart"
      })
    } finally {
      this.editBookingInProgress = false
    }
  }

  editCartItem = (slot) => {
    this.setState({
      bookingToEdit: slot,
      bookingPriceToEdit: slot.reservation_price_without_promo,
      bookingPlayersToEdit: parseInt(slot.quantity_player, 10),
      showPopInEdit: true
    })
  }

  deleteCartItem = async (slot) => {
    const idReservation = slot.id
    const idReservationToken = this.findToken(parseInt(slot.id, 10))

    const body = {
      id_reservation: idReservation,
      token_reservation: idReservationToken
    }
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const bookings = cookies.get('bookings').filter(x => x.id !== slot.id)
      cookies.set('bookings', safeBookingsForCookie(bookings), cartCookieOptions())
      this.buildSchedules(this.state.selectedTheme, this.state.date)
      this.updateBookings()
      this.setState({ calendarKey: this.state.calendarKey + 1}) // To prevent a bug of slot not being bookable after deleted from cart
    })
    .catch(error => console.log(error))
  }

  handlePlayerQuantity = async (data) => {
    const players = data
    const pricingRequestId = (this.pricingRequestId || 0) + 1
    this.pricingRequestId = pricingRequestId
    this.setState({ players: players, isPricing: true })
    try {
      const totalPrice = await this.getTotalPrice(this.state.currentSlot, players, this.state.priceType)
      if (this.pricingRequestId !== pricingRequestId) return
      this.setState({ totalPrice: totalPrice, isPricing: false })
    } catch (error) {
      console.log(error)
      if (this.pricingRequestId === pricingRequestId) this.setState({ isPricing: false })
    }
  }

  handlePlayerQuantityEdit = async (data) => {
    const players = data
    const pricingRequestId = (this.editPricingRequestId || 0) + 1
    this.editPricingRequestId = pricingRequestId
    const slot = `${this.themeFromRoomId(this.state.bookingToEdit.room_id)}|${this.state.bookingToEdit.reservation_date}|${this.state.bookingToEdit.time_begin.split(":").shift()}|||${this.state.bookingToEdit.room_id}`
    this.setState({ bookingPlayersToEdit: players, isEditPricing: true })
    try {
      const priceType = await this.getPriceType(slot)
      const totalPrice = await this.getTotalPrice(slot, players, priceType)
      if (this.editPricingRequestId !== pricingRequestId) return
      this.setState({ bookingPriceToEdit: totalPrice, priceType: priceType, isEditPricing: false })
    } catch (error) {
      console.log(error)
      if (this.editPricingRequestId === pricingRequestId) this.setState({ isEditPricing: false })
    }
  }

  getWeekDay = (date) => {
    const newDate = createMomentFromEnglish(date, this.props.lang)
    if (this.props.lang === "fr") {
      const lastIndex = newDate.format('LLLL').lastIndexOf(" ")
      return newDate.format('LLLL').substring(0, lastIndex)
    } else {
      return newDate.format('ll')
    }
  }

  buildPopinDate = (date, hour, minutes) => {
    if (this.props.lang === "fr") {
      return `${this.getWeekDay(date)} à ${hour}h${minutes}`
    } else {
      return `${this.getWeekDay(date)}, ${getEnglishHour(hour)}:${minutes} ${getEnglishHourAMPM(hour)}`
    }
  }

  getVBNOptionPrice = () => {
    return this.getRoomPricingData()
      .then(rooms => {
        const optionsByRoom = {}
        const roomIdsByTheme = Object.keys(this.state.roomIdsByTheme || {}).length > 0
          ? this.state.roomIdsByTheme
          : (this.roomIdsByThemeCache || {})

        rooms.forEach(room => {
          const options = Array.isArray(room.options) ? room.options : []
          const roomId = room.id_room || room.id || room.room_id || room.id_room_escape || room.id_room_enigma
          const roomTheme = roomThemeFromName(`${room.room_name || ''} ${room.enigma_name || ''} ${room.roomname || ''} ${room.name || ''}`)

          if (roomId) optionsByRoom[roomId] = options

          // Keep both API and calendar IDs so returning from the cart does not
          // lose options when the two systems use different room references.
          if (roomTheme) {
            const mappedRoomId = roomIdsByTheme[roomTheme]
            if (mappedRoomId) optionsByRoom[mappedRoomId] = options
            if (LOCAL_ROOM_IDS_BY_THEME[roomTheme]) optionsByRoom[LOCAL_ROOM_IDS_BY_THEME[roomTheme]] = options
          }
        })
        this.roomOptionsByRoomCache = optionsByRoom
        const vbnRoomId = (this.state.roomIdsByTheme && this.state.roomIdsByTheme.vbn)
          || (this.roomIdsByThemeCache && this.roomIdsByThemeCache.vbn)
        const vbnRoom = rooms.filter(x => `${x.id_room}` === `${vbnRoomId}`).shift()
          || rooms.filter(x => roomThemeFromName(`${x.room_name || ''} ${x.enigma_name || ''} ${x.roomname || ''} ${x.name || ''}`) === "vbn").shift()
        const vbnOption = vbnRoom && Array.isArray(vbnRoom.options)
          ? vbnRoom.options.find(option => {
              const text = `${option.name || option.room_option_name || ''} ${option.description || option.room_option_description || ''}`.toLowerCase()
              const price = parseFloat(option.price || option.room_option_price || option.room_option_price_without_promo || 0)
              return (text.indexOf('personnalis') !== -1 || text.indexOf('custom') !== -1 || Math.abs(price - 50) < 0.01)
                && text.indexOf('anniversaire') === -1
                && text.indexOf('birthday') === -1
                && text.indexOf('vid') === -1
            })
          : null
        this.setState({
          VBNOptionPrice: vbnOption ? vbnOption.price : 0,
          roomOptionsByRoom: optionsByRoom
        })
        return optionsByRoom
      })
      .catch(error => {
        console.log(error)
        return { min: 2, max: 6 }
      })
  }

  preloadRoomPricingData = () => {
    this.getVBNOptionPrice()
      .catch(error => console.log(error))
  }

  getVbnOptionIdForRoom = (room) => {
    const optionsByRoom = Object.keys(this.state.roomOptionsByRoom).length > 0
      ? this.state.roomOptionsByRoom
      : (this.roomOptionsByRoomCache || {})
    const options = optionsByRoom[room] || []
    const option = options.find(candidate => {
      const text = `${candidate.name || candidate.room_option_name || ''} ${candidate.description || candidate.room_option_description || ''}`.toLowerCase()
      const price = parseFloat(candidate.price || candidate.room_option_price || candidate.room_option_price_without_promo || 0)
      return (text.indexOf('personnalis') !== -1 || text.indexOf('custom') !== -1 || Math.abs(price - 50) < 0.01)
        && text.indexOf('anniversaire') === -1
        && text.indexOf('birthday') === -1
        && text.indexOf('vid') === -1
    })
    return option ? (option.id || option.id_room_option || option.room_option_id || '') : ''
  }

  getPriceType = async (slot) => {
    const slotInfo = parseCalendarSlotValue(slot)
    if (slotInfo.priceType) return slotInfo.priceType

    const room = this.resolveRoomId(slotInfo.theme, slot)
    const date = slotInfo.date
    const hour = slotInfo.hour

    const findPriceType = (calendar) => {
      const slotPrice = Array.isArray(calendar)
        ? calendar.filter(x => x.time_begin && x.time_begin.startsWith(hour)).shift()
        : null

      return slotPrice ? slotPrice.global_price : null
    }

    let response = await this.getCompanyCalendarForDate(date, this.getCompanyId())
      .then(slots => {
        const roomSlot = slots.filter(x => `${x.id_room}` === `${room}`).shift()
        const calendar = roomSlot && roomSlot.calendar ? roomSlot.calendar : []
        return findPriceType(calendar)
      })
      .catch(error => console.log(error))

    if (!response) {
      response = await axios.get(buildAPI_URL(slotInfo.theme, date, this.props.lang, room, this.getCompanyId()), {
        timeout: CALENDAR_REQUEST_TIMEOUT
      })
        .then(response => {
          const weekSlots = response.data && Array.isArray(response.data.slots) ? response.data.slots : []
          return findPriceType(this.getCalendarForSelectedDate(weekSlots, date))
        })
        .catch(error => console.log(error))
    }

    return response || 'c'
  }

  getLastMinuteDiscount = async (slot) => {
    const slotInfo = parseCalendarSlotValue(slot)
    const hasDiscountInSlot = slotInfo.discountRaw !== ''
    const discountFromSlot = parseFloat(slotInfo.discountRaw || 0)
    if (hasDiscountInSlot && Number.isFinite(discountFromSlot)) return discountFromSlot

    const room = this.resolveRoomId(slotInfo.theme, slot)
    const date = slotInfo.date
    const hour = slotInfo.hour

    const findDiscount = (calendar) => {
      const slotPrice = Array.isArray(calendar)
        ? calendar.filter(x => x.time_begin && x.time_begin.startsWith(hour)).shift()
        : null

      return slotPrice ? parseFloat(slotPrice.last_minute_discount_amount || 0) : null
    }

    let response = await this.getCompanyCalendarForDate(date, this.getCompanyId())
      .then(slots => {
        const roomSlot = slots.filter(x => `${x.id_room}` === `${room}`).shift()
        const calendar = roomSlot && roomSlot.calendar ? roomSlot.calendar : []
        return findDiscount(calendar)
      })
      .catch(error => console.log(error))

    if (response === null || response === undefined || Number.isNaN(response)) {
      response = await axios.get(buildAPI_URL(slotInfo.theme, date, this.props.lang, room, this.getCompanyId()), {
        timeout: CALENDAR_REQUEST_TIMEOUT
      })
        .then(response => {
          const weekSlots = response.data && Array.isArray(response.data.slots) ? response.data.slots : []
          return findDiscount(this.getCalendarForSelectedDate(weekSlots, date))
        })
        .catch(error => console.log(error))
    }

    return response || 0
  }

  getTotalPrice = async (slot, playersQuantity, priceType) => {
    const slotInfo = parseCalendarSlotValue(slot)
    const room = this.resolveRoomId(slotInfo.theme, slot)
    const resolvedPriceType = priceType || slotInfo.priceType || await this.getPriceType(slot)
    const priceKey = `price_h${resolvedPriceType || 'c'}`
    const findPrice = (rooms) => {
      const roomInfo = this.findRoomPricingInfo(rooms, room)
      if (!roomInfo || !roomInfo.prices) return null
      const price = roomInfo.prices.filter(x => x.quantity_player === playersQuantity.toString()).shift()
      if (!price) return null
      return price[priceKey] || price.price_hc || price.price_hp || price.price_hp2
    }

    let response = await this.getRoomPricingData()
      .then(rooms => {
        return findPrice(rooms)
      })
      .catch(error => console.log(error))

    if (response === null || response === undefined || response === '') {
      response = await this.refreshRoomPricingData(this.getCompanyId())
        .then(rooms => findPrice(rooms))
        .catch(error => console.log(error))
    }

    const discount = slotInfo.discountRaw !== ''
      ? parseFloat(slotInfo.discountRaw || 0)
      : await this.getLastMinuteDiscount(slot)
    return Math.max(0, parseFloat(response || 0) - discount)
  }

  postCreateOrder = async (slot) => {
    const url = `${API_ROOT}FrontCreateOrderWithReservation.php`

    const id_room_calendar = slot.split("|")[3]
    const date = slot.split("|")[1]
    const room = this.resolveRoomId(slot.split("|")[0], slot)
    const id_room_option = this.props.VBNOption ? this.getVbnOptionIdForRoom(room) : ""

    let lang = encodeLanguage(this.state.language);
    if (31 == parseInt(room)) {
      lang = encodeLanguage("french");
    }

    const body = {
      id_room_option: id_room_option,
      id_room_calendar: id_room_calendar,
      id_room: room,
      reservation_date: date,
      quantity_player: this.state.players,
      price: this.state.totalPrice,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(async (data) => {
      const cookies = new Cookies()
      const newBooking = data.order_details.rooms.filter(x => x.id === data.reservation_added.id_room_reservation.toString()).shift()
      const bookingsTokens = []
      const newBookingToken = {
        id_room_reservation: data.reservation_added.id_room_reservation,
        id_room_reservation_token: data.reservation_added.id_room_reservation_token
      }
      bookingsTokens.push(newBookingToken)
      const bookings = []
      bookings.push(newBooking)
      cookies.set('bookingsTokens', bookingsTokens, cartCookieOptions())
      cookies.set('bookings', safeBookingsForCookie(bookings), cartCookieOptions())
      cookies.set('orderDetails', safeOrderDetailsForCookie(data), cartCookieOptions())

      if (cookies.get("vouchers")) {
        cookies.remove("vouchers")
      }

      if (cookies.get("orderDetailsVouchers")) {
        cookies.remove("orderDetailsVouchers")
      }
      await this.updateBookings()
      this.props.expiration()
    })
    .catch(error => {
      console.log(error)
      alert("Impossible d'ajouter cette réservation au panier. Merci de réessayer.")
    })
  }

  findToken = (id) => {
    const cookies = new Cookies()
    if (cookies.get("bookingsTokens"))
      return cookies.get("bookingsTokens").filter(x => x.id_room_reservation === id).shift().id_room_reservation_token
    else
      return cookies.get("bookings").filter(x => parseInt(x.id) === id).shift().id_room_reservation_token
  }

  addBookingToOrder = async (slot) => {
    const url = `${API_ROOT}FrontAddReservationToOrder.php`

    const cookies = new Cookies()
    const orderCookie = this.getOrderCookie()
    if (!orderCookie || !orderCookie.id_order_escape || !orderCookie.id_order_escape_token) {
      throw new Error("Commande panier introuvable")
    }
    const orderId = orderCookie.id_order_escape
    const orderToken = orderCookie.id_order_escape_token
    const id_room_calendar = slot.split("|")[3]
    const date = slot.split("|")[1]
    const room = this.resolveRoomId(slot.split("|")[0], slot)
    const id_room_option = this.props.VBNOption ? this.getVbnOptionIdForRoom(room) : ""

    let lang = encodeLanguage(this.state.language);
    if (31 == parseInt(room)) {
      lang = encodeLanguage("french");
    }


    const body = {
      id_order: orderId,
      token_order: orderToken,
      id_room_option: id_room_option,
      id_room_calendar: id_room_calendar,
      id_room: room,
      reservation_date: date,
      quantity_player: this.state.players,
      price: this.state.totalPrice,
      lang: lang
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const newBooking = data.order_details.rooms.filter(x => x.id === data.reservation_added.id_room_reservation.toString()).shift()
      newBooking.id_room_reservation_token = data.reservation_added.id_room_reservation_token
      const bookings = this.state.bookings
      bookings.push(newBooking)
      const bookingsTokens = cookies.get("bookingsTokens") || []
      const newBookingToken = {
        id_room_reservation: data.reservation_added.id_room_reservation,
        id_room_reservation_token: data.reservation_added.id_room_reservation_token
      }
      bookingsTokens.push(newBookingToken)
      cookies.set('bookingsTokens', bookingsTokens, cartCookieOptions())
      cookies.set('bookings', safeBookingsForCookie(bookings), cartCookieOptions())
      this.updateBookings()

    })
    .catch(error => {
      console.log(error)
      alert("Impossible d'ajouter cette réservation au panier. Merci de réessayer.")
    })
  }

  updateBookings = async () => {
    this.setState({ bookings: [] })
    const bookings = []
    const cookies = new Cookies()
    const orderDetails = cookies.get('orderDetails')

    if (orderDetails && (orderDetails.option_payment_mode === true || orderDetails.option_payment_mode === "1")) {
      clearCartCookies(cookies)
      return
    }

    if (Array.isArray(cookies.get('bookings'))) {
      const optionStates = cookies.get('bookingOptionStates') || {}
      cookies.get('bookings').forEach(reservation => {
        const persistedOptions = optionStates[`${reservation.id}`]
          || optionStates[`${reservation.id_room_reservation}`]
        bookings.push(persistedOptions
          ? {
              ...reservation,
              room_options: persistedOptions.room_options || [],
              price_reservation_total: persistedOptions.price_reservation_total,
              price_reservation_total_without_promo: persistedOptions.price_reservation_total_without_promo
            }
          : reservation)
      })
      this.setState({ bookings: bookings })
    }
  }

  updateNewBookings = (booking) => {
    const cookies = new Cookies()
    const bookings = booking.rooms
    cookies.set('bookings', safeBookingsForCookie(bookings), cartCookieOptions())
    this.setState({ bookings: bookings })
  }

  updateOrder = async () => {
    const cookies = new Cookies()
    const idOrder = cookies.get("orderDetails").id_order_escape.toString()
    const tokenOrder = cookies.get("orderDetails").id_order_escape_token
    return await axios.get(buildAPI_URL_Order(idOrder, tokenOrder))
      .then(response => {
        console.log(response.data)
      })
      .catch(error => console.log(error))
  }

  checkUrlParams = () => {
    const search = window.location.search
    if (search) {
      let params = new URLSearchParams(search)
      if (!params.get('date') || !params.get('time') || !params.get('roomId')) return
      this.setUrlParamsToState(params)
    }
  }

  setUrlParamsToState = async params => {
    const date = params.get('date')
    const rawTime = params.get('time')
    const time = rawTime ? rawTime.split(':')[0] : null
    const roomId = invertFormatRoom(parseInt(params.get('roomId'), 10))

    if (date) {
      this.setState({ date: moment(new Date(date)) })
    }

    if (roomId) {
      this.setState({ selectedTheme: roomId })
    }

    if (date && time && roomId) {
      await this.buildSchedules(roomId, moment(new Date(date)))
      const cell = document.querySelector(`[id*="|${date}|${time}"]`)
      if (cell) {
        cell.click()
      }
    }
  }


  async componentDidMount() {
    // http://localhost:3000/reserver?date=2020-07-04&time=10:00:00&roomId=28
    this.checkUrlParams()

    await this.updateBookings()
    if (this.props.theme) {
      this.setState({
        selectedTheme: this.props.theme
      })
    }
    try {
      await this.getRoomIdsByTheme()
    } catch (error) {
      console.log(error)
    }
    this.preloadRoomPricingData()
    this.buildSchedules(this.state.selectedTheme, this.state.date)
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const activeSlot = this.displaySlot(this.state.currentSlot)
    const editPlayerLimits = this.state.bookingToEdit
      ? this.getPlayerInfoForRoomSync(this.state.bookingToEdit.room_id)
      : { min: 2, max: 5 }
    const editCtaClass = this.state.isEditPricing ? ' theme-popin-cta--disabled' : ''
    const ctaClass = this.state.isPricing ? ' theme-popin-cta--disabled' : ''

    const languageLabelStyle = this.state.language === ""
      ? "language-select-label"
      : "language-select-label langage-select-label--selected"

    const languageOptions = {
      frenchOnly: [
        { value: 'french', label: 'Français', className: 'language-select-option' }
        ],
      all: [
        { value: 'french', label: 'Français', className: 'language-select-option' },
        { value: 'english', label: 'English', className: 'language-select-option' },
      ]
    }

    const themeOrder = this.getThemeOrder()
    const defaultRoomIdsByTheme = themeOrder.reduce((acc, theme) => {
      acc[theme] = formatRoom(theme)
      return acc
    }, {})

    const visibleRoomIdsByTheme = Object.keys(this.state.roomIdsByTheme).length > 0
      ? this.state.roomIdsByTheme
      : Object.keys(this.roomIdsByThemeCache || {}).length > 0
      ? this.roomIdsByThemeCache
      : isLocalFront()
      ? LOCAL_ROOM_IDS_BY_THEME
      : defaultRoomIdsByTheme

    const fallbackAllThemeSlots = themeOrder
      .map(theme => ({
        id_room: visibleRoomIdsByTheme[theme] || formatRoom(theme),
        room: theme,
        calendar: []
      }))
      .filter(slot => slot.id_room)

    const visibleAllThemeSlots = this.state.slots.length > 0
      ? this.state.slots
      : fallbackAllThemeSlots

    const visibleWeekSlots = this.state.weekSlots.length > 0
      ? this.state.weekSlots
      : this.buildEmptyWeekSlots(this.state.date)

    return (
      <div className="booking-container" id="booking">
        <div className="booking-rectangle">
          <div
            style={{backgroundImage: `url(${FAQPattern})`}}
            className="booking-rectangle-pattern"></div>
        </div>
        <div className={`booking-text-block ${this.props.noTitle ? "booking-text-block--padding" : ""}`}>
          {
            this.props.noTitle
            ? null
            : <h3>{formatMessage(messages.title)}</h3>
          }
          <p id="booking-smoothscroll-level">{formatMessage(messages.intro)}</p>
        </div>
        <ThemePicker
          selectedTheme={this.state.selectedTheme}
          handleChange={ theme => this.changeTheme(theme)}
          allowedThemes={themeOrder}
          allRoomsLabel={this.props.allRoomsLabel}
        />
        <Select
          aria-label={formatMessage(messages.themeSelectLabel)}
          valueComponent={AccessibleSelectValue}
          onFocus={(e) => document.getElementsByClassName("select-theme-mobile")[0].style.zIndex = 11}
          onBlur={(e) => document.getElementsByClassName("select-theme-mobile")[0].style.zIndex = 0 }
          id="booking-theme-select"
          instanceId="booking-theme-select"
          name="theme"
          value={this.state.selectedTheme}
          onChange={(e) => this.changeTheme(e.value)}
          className={"language-select select-theme-mobile"}
          searchable={false}
          clearable={false}
          placeholder={""}
          options={[
            { value: 'all', label: this.props.allRoomsLabel || 'Toutes les salles', className: 'language-select-option' },
            { value: 'la', label: 'Lost Asylum', className: 'language-select-option' },
            { value: 'vbn', label: 'Very Bad Night', className: 'language-select-option' },
            { value: 'abattoir', label: "L'abattoir", className: 'language-select-option' },
            // TODO : A décommenter pour Yakuza
            { value: 'yakuza', label: "Yakuza", className: 'language-select-option' },
			{ value: 'tombeau', label: "Expédition Maudite", className: 'language-select-option' }
          ].filter(option => option.value === 'all' || themeOrder.indexOf(option.value) > -1)}
        />
        <DatePicker
          date={this.state.date}
          selectedTheme={this.state.selectedTheme}
          handleChange={ date => this.changeDate(date)}
          lang={this.props.lang}
          />

          <div className="calendar-container">
            {this.state.loading && (
              <div className="loader-overlay">
                <div className="loader"></div>
              </div>
            )}

            {this.state.selectedTheme === "all" && visibleAllThemeSlots.length > 0 && (
              <AllThemesCalendar
                key={this.state.calendarKey}
                date={this.state.date}
                lang={this.props.lang}
                slots={visibleAllThemeSlots}
                roomIdsByTheme={visibleRoomIdsByTheme}
                selectedSlots={this.state.bookings}
                handleClick={data => this.handleSelect(data)}
                handleNextDay={() => this.changeDate(this.state.date.clone().add(1, 'day'))}
                allowedThemes={themeOrder}
              />
            )}
            {this.state.selectedTheme !== "all" && visibleWeekSlots.length > 0 && (
              <ThemeCalendar
                date={this.state.date}
                theme={this.state.selectedTheme}
                lang={this.props.lang}
                weekDays={this.state.weekDays}
                slots={visibleWeekSlots}
                roomIdsByTheme={visibleRoomIdsByTheme}
                selectedSlots={this.state.bookings}
                handleClick={data => this.handleSelect(data)}
              />
            )}
          </div>

        {
          this.state.bookings.length > 0 && <p className="booking-themes-cart-title">{formatMessage(messages.selectedThemeTitle)} :</p>
        }

         {
            Object.keys(this.state.bookings).map((x, i) =>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionAppear={true}
                key={`transition-${i}`}
                transitionAppearTimeout={500}
                transitionEnterTimeout={0}
                transitionLeaveTimeout={0}>
              <ThemesCart
                key={i}
                slot={this.state.bookings[x]}
                lang={this.props.lang}
                editCartItem={slot => this.editCartItem(slot)}
                deleteCartItem={slot => this.deleteCartItem(slot)}
                VBNOptionPrice={this.state.VBNOptionPrice}
                roomOptionsByRoom={this.state.roomOptionsByRoom}
                roomIdsByTheme={visibleRoomIdsByTheme}
                togglePopInVBNCustom={() => this.togglePopInVBNCustom()}
                togglePopInVideoPack={() => this.togglePopInVideoPack()}
                closeOptionPopIns={() => this.setState({ showPopInVBNCustom: false, showPopInVideoPack: false })}
                handleOption={(optionId, resaId, resaToken, hasOption) => this.toggleOption(optionId, resaId, resaToken, hasOption)}
                updateBookings={(booking) => this.updateNewBookings(booking)}
              />
              </ReactCSSTransitionGroup>

            )
         }
         {
          this.state.bookings.length > 0
            ?
              <Link to="/cart">
                <div id="booking-cta"><LearnMoreButton text={formatMessage(messages.book)} styleClass={"themes-cart-cta"}/></div>
              </Link>
            : null
         }
        {
          this.state.showPopInEdit
          ?
            <PopIn
              closePopIn={() => this.setState({ showPopInEdit: false })}
              small
              style={{padding: "0"}}
            >
              <div className="theme-popin">
                <div className="theme-popin-icon">
                  <img src={themeToImageConverter(this.themeFromRoomId(this.state.bookingToEdit.room_id))} alt=""/>
                </div>
                <h2>{this.state.bookingToEdit.room_name}</h2>
                <p className="theme-popin-date">{this.buildPopinDate(createMoment(this.state.bookingToEdit.reservation_date).format('l'), this.state.bookingToEdit.time_begin.split(":").shift(), this.state.bookingToEdit.time_begin.split(":")[1])}</p>
                <p className="theme-players-select-label">{formatMessage(messages.popinPlayerChoice)}</p>
                <span className="theme-players-minmax">{formatMessage(messages.popinPlayerMinMax, {max: editPlayerLimits.max})}</span>
                <PlayersPicker
                  players={this.state.bookingPlayersToEdit}
                  pickPlayers={(data) => this.handlePlayerQuantityEdit(data)}
                  playerMin={editPlayerLimits.min}
                  playerMax={editPlayerLimits.max}
                  />
                <p className="theme-language-select-label">{formatMessage(messages.popinLanguageChoice)}</p>
                <div className="theme-popin-select-language">
                  <Select
                    aria-label={formatMessage(messages.popinLanguageChoice)}
                    valueComponent={AccessibleSelectValue}
                    id="booking-edit-language-select"
                    instanceId="booking-edit-language-select"
                    name="language"
                    value={this.state.bookingToEdit.room_id === "31" ? languageOptions.frenchOnly[0].value : this.state.language}
                    onChange={(e) => this.handleLanguage(e.value)}
                    className={"language-select"}
                    searchable={false}
                    clearable={false}
                    placeholder={""}
                    options={this.state.bookingToEdit.room_id === "31" ? languageOptions.frenchOnly : languageOptions.all}
                  />
                  <span className={languageLabelStyle}>{formatMessage(messages.popinLanguageLabel)}</span>
                </div>
                <h3><span>{Math.floor(this.getPricePerPlayer(this.state.bookingPriceToEdit, this.state.bookingPlayersToEdit ))},<sup>{(Math.round((this.getPricePerPlayer(this.state.bookingPriceToEdit, this.state.bookingPlayersToEdit ) % 1) * 100) / 100).toFixed(2).split(".")[1]}</sup>€</span>/ PERS. {formatMessage(messages.popinTotalPrice)} {this.state.bookingPriceToEdit}€</h3>
                <div className="theme-popin-footer">
                  <div className={`theme-popin-cta theme-popin-cta--blank${editCtaClass}`} onClick={() => this.handleContinueBookingAfterEdit()}>{formatMessage(messages.popinBookAndContinue)}</div>
                  <div className={`theme-popin-cta${editCtaClass}`} onClick={() => this.handleGoToCartAfterEdit()}>{formatMessage(messages.popinBookAndPay)}</div>
                </div>
              </div>
            </PopIn>
          : null
        }
        {
          this.state.showPopIn && activeSlot
          ?
            <PopIn
              closePopIn={this.togglePopIn.bind(this)}
              small
              style={{padding: "0"}}
            >
              <div className="theme-popin">
                <div className="theme-popin-icon">
                  <img src={themeToImageConverter(this.codeToThemeConverter(activeSlot.room))} alt=""/>
                </div>
                <h2>{activeSlot.room}</h2>
                <p className="theme-popin-date">{this.buildPopinDate(activeSlot.date, activeSlot.hour, activeSlot.minutes)}</p>
                <p className="theme-players-select-label">{formatMessage(messages.popinPlayerChoice)}</p>
                <span className="theme-players-minmax">{formatMessage(messages.popinPlayerMinMax, {max: this.state.playersQuantityInfo.max})}</span>
                <PlayersPicker
                  players={this.state.players}
                  pickPlayers={(data) => this.handlePlayerQuantity(data)}
                  playerMin={this.state.playersQuantityInfo.min}
                  playerMax={this.state.playersQuantityInfo.max}
                  />
                <p className="theme-language-select-label">{formatMessage(messages.popinLanguageChoice)}</p>
                <div className="theme-popin-select-language">
                  <Select
                    aria-label={formatMessage(messages.popinLanguageChoice)}
                    valueComponent={AccessibleSelectValue}
                    id="booking-language-select"
                    instanceId="booking-language-select"
                    name="language"
                    value={this.state.currentSlot.split("|")[0] === "yakuza" ? languageOptions.frenchOnly[0].value : this.state.language}
                    onChange={(e) => this.handleLanguage(e.value)}
                    className={"language-select"}
                    searchable={false}
                    clearable={false}
                    placeholder={""}
                    options={this.state.currentSlot.split("|")[0] === "yakuza" ? languageOptions.frenchOnly : languageOptions.all}
					//options={this.state.currentSlot.split("|")[0] === "tombeau" ? languageOptions.frenchOnly : languageOptions.all}
                  />
                  <span className={languageLabelStyle}>{formatMessage(messages.popinLanguageLabel)}</span>
                </div>
                {
                  this.state.isPricing
                  ? <h3><span>Calcul...</span></h3>
                  : <h3><span>{Math.floor(this.getPricePerPlayer(this.state.totalPrice, this.state.players ))},<sup>{(Math.round((this.getPricePerPlayer(this.state.totalPrice, this.state.players ) % 1) * 100) / 100).toFixed(2).split(".")[1]}</sup>€</span>/ PERS. {formatMessage(messages.popinTotalPrice)} {this.state.totalPrice}€</h3>
                }
                <div className="theme-popin-footer">
                  <div className={`theme-popin-cta theme-popin-cta--blank${ctaClass}`} onClick={() => this.handleContinueBooking()}>{formatMessage(messages.popinBookAndContinue)}</div>
                  <div className={`theme-popin-cta${ctaClass}`} onClick={() => this.handleGoToCart()}>{formatMessage(messages.popinBookAndPay)}</div>
                </div>
              </div>
            </PopIn>
          : null
        }
        {
          this.state.showPopInVBNCustom
          ? <PopInVBNCustom closePopIn={() => this.togglePopInVBNCustom()} />
          : null
        }
        {
          this.state.showPopInVideoPack
          ? <PopInVideoPack closePopIn={() => this.togglePopInVideoPack()} />
          : null
        }
        {
          this.state.showPopInLimitBooking
          ?
            <PopIn small klass="pop-in-limit" closePopIn={() => this.setState({ showPopInLimitBooking: false })}>
              <p>{formatMessage(messages.tooManyBookings)}</p>
            </PopIn>
          : null
        }
      </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'bookingContainer.title',
    defaultMessage: 'Réserver'
  },
  pricing: {
    id: 'booking.pricing',
    defaultMessage: 'Tarifs'
  },
  intro: {
    id: 'bookingContainer.intro',
    defaultMessage: 'Choisissez le(s) thème(s) et le(s) créneau(x) horaire de votre choix :'
  },
  book: {
    id: 'bookingContainer.book',
    defaultMessage: 'Réserver'
  },
  popinPlayerChoice: {
    id: 'bookingContainer.popinPlayerChoice',
    defaultMessage: "Choisissez le nombre de joueurs :"
  },
  popinPlayerMinMax: {
    id: 'bookingContainer.popinPlayerMinMax',
    defaultMessage: "(2 min. / {max} max.)"
  },
  popinLanguageChoice: {
    id: 'bookingContainer.popinLanguageChoice',
    defaultMessage: "Choisissez la langue :"
  },
  popinLanguageLabel: {
    id: 'bookingContainer.popinLanguageLabel',
    defaultMessage: "Langue :"
  },
  popinPricePerPlayer: {
    id: 'bookingContainer.popinPricePerPlayer',
    defaultMessage: "Prix par joueur :"
  },
  popinTotalPrice: {
    id: 'bookingContainer.popinTotalPrice',
    defaultMessage: "soit"
  },
  popinBookAndContinue: {
    id: 'bookingContainer.popinBookAndContinue',
    defaultMessage: "Ajouter une autre réservation"
  },
  popinBookAndPay: {
    id: 'bookingContainer.popinBookAndPay',
    defaultMessage: "Réserver et payer"
  },
  la: {
    id: 'themes.la',
    defaultMessage: 'Lost Asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Mission Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'expédition maudite"
  },
  selectedThemeTitle: {
    id: 'bookingContainer.selectedThemeTitle',
    defaultMessage: "Thème(s) choisi(s)"
  },
  themeSelectLabel: {
    id: 'bookingContainer.themeSelectLabel',
    defaultMessage: "Choisir une salle"
  },
  tooManyBookings: {
    id: 'bookingContainer.tooManyBookings',
    defaultMessage: "Vous ne pouvez pas réserver plus de 6 créneaux !"
  },
})

export default withRouter(injectIntl(BookingContainer))



// WEBPACK FOOTER //
// ./src/components/BookingContainer.js